import { IReservationDocument } from '../interfaces/reservation-document.interface';
export class ReservationDocument {
  public type: string;
  public name: string;
  public url: string;

  constructor(data?: IReservationDocument) {
    Object.assign(this, data);
  }
}
